import { Injectable } from '@angular/core';
import { InvoiceDataService } from '../data-services/invoice-data.service';
import { GenericResponse } from '../business-entities/generic-response';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {
  Id: number;
  constructor(private service: InvoiceDataService) { }

  async getDocumentWarning(workOrderNo: string, languageCode: string) {
    return this.service.getDocumentWarning(workOrderNo, languageCode);
  }
  async GenerateInvoice(InvoiceGenerateModel: any): Promise<GenericResponse<any>> {
    return this.service.GenerateInvoice(InvoiceGenerateModel);
  }
  async getPostedInvoiceByWo(appointmentId: number, workOrderNo: string) {
    return this.service.getPostedInvoiceByWo(appointmentId, workOrderNo);
  }
  async getInvoiceDocument(invoiceNo: string, languageCode: string) {
    return this.service.getInvoiceDocument(invoiceNo, languageCode);
  }
  async getInvoicePreview(invoicePreviewRequestModel: any) {
    return this.service.getInvoicePreview(invoicePreviewRequestModel);
  }
}
